import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getOne=(id,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_TWOD_COLLECTION_START
    })
    const options={
        url:`${api}/twoDCollections/${id}`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_TWOD_COLLECTION_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_TWOD_COLLECTION_FAIL,
                payload:getMessage(error)
            }))
}